// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    height: 100%;
    font-size: 14px;
    line-height: 1.15;
}

body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.45;
    background-color: #f3f3f3;
    text-align: left;
    /*color: #55595c;*/
    color: #000;
    overflow-x: hidden;
}

body * {
    box-sizing: border-box;
}

.overflow-x-auto {
    overflow-x: auto;
}

#root {
    height: 100%;
    display: flex;
}

#root > div {
    flex: 1;
    display:flex;
    flex-direction: column;
}

.flex-box {
    display: flex;
}

.top-of-content-marker {
    position: absolute;
    top: 0;
}

.bg-white {
    background-color: white !important;
}

.bg-gray {
    background-color: #fefefe;
}

.bg-dark-gray {
    background-color: #ccc;
}

.bg-cyan {
    background-color: #BA324F;
}
.bg-yellow:not(.no-style) {
    background-color: #fff9ae;
}
.bg-baby-blue:not(.no-style) {
    background-color: #b9e4f6;
}
.text-vertical {
    writing-mode: vertical-rl;
}

.hover-bg-white:hover {
    background-color: white !important;
}

.hover-bg-gray:hover {
    background-color: #fefefe;
}

.hover-bg-dark-gray:hover {
    background-color: #ccc;
}

.hover-bg-cyan:hover {
    background-color: #BA324F;
}

.cursor-pointer {
    cursor: pointer !important;
}

.no-wrap {
    white-space: nowrap;
}

.cursor-default {
    cursor: default !important;
}

.page-wrapper {
    display: flex;
    flex: 1;
    overflow-y: auto;
}

.page-wrapper main {
    flex: 1;
    min-width: 0;
    padding: 1rem;
    overflow: hidden auto;
    display: flex;
    flex-direction: column;
    position: relative;
}

.page-wrapper main > div {
    flex: 1;
    min-width: 0;
}

.page-wrapper > main > footer {
    font-size: .75rem;
    text-align: center;
    padding-top: 1rem;
}

.copy-right-container {
    display: flex;
}

.copy-right-container img {
    margin: auto 0 auto auto;
    height: .75rem;
}

.copy-right-container span {
    margin: auto auto auto .5rem;
}

.page-wrapper > main > footer span.loading-placeholder {
    width: 20rem;
}

.report-wrapper {
    overflow-x: auto;
}

.report {
    margin-left: auto;
    margin-right: auto;
    padding: 1rem;
    max-width: 77rem;
    color:black;
}

.report.allow-overflow {
    max-width: unset;
}

.report-page table .bg-gray {
    background-color: #EEE;
}

.report-page table .bg-black {
    background-color: #55595C;
    color: #FFF;
}

.report-page .user-profile-image {
    width: 5rem;
    height: 5rem;
}

.report-page .ti-user-alt {
    font-size: 5rem !important;
    color: #efefef;
}

.report-page table {
    border-collapse: collapse;
    width: 100%;
}

.report-page td:not(.no-style) {
    border: 1px solid #ccc;
}

.report-page th:not(.no-style) {
    border-bottom: 2px solid #55595c;
}

.report-page td:not(.no-style), .report-page th:not(.no-style) {
    padding: .5rem;
}

.report .report-page {
    background: #ffffff;
    padding: 1rem;
}

.report .report-page + .report-page {
    margin-top: 4rem;
    page-break-before: always;
}

.event-overview .header {
    display: flex;
}

.event-overview .header .date {
    background-color: #005377;
    color: white;
    padding: 1rem;
    margin-right: 1rem;
}

.event-overview .header .date > div:first-of-type {
    font-size: 1.75rem;
}

.event-overview .header .date > div:last-of-type {
    font-size: 1rem;
}

.event-overview .header .name {
    border: 1px solid #ccc;
    flex: 1;
    padding: 1rem;
}

.event-overview .header .name div:first-of-type {
    font-size: 1.5rem;
}

.event-overview .header .name div:last-of-type {
    font-size: .85rem;
}

.event-overview .pane {
    border: 1px solid #ccc;
    background-color: #f3f3f3;
    font-size: .8rem;
    margin-bottom: 1rem;
}

.event-overview .pane .flex,
.event-overview .pane.flex {
    flex-wrap: wrap;
}

.event-overview .pane > .flex-col-2 {
    width: 100%;
    justify-content: space-between;
    padding: 1rem;
}

.event-overview .pane > .flex > .flex-col-3,
.event-overview .pane.flex > .sub-1 {
    width: 100%;
    justify-content: space-between;
    padding: 1rem;
}

.configuration-page .tool-accordion-header {
    border-bottom: 2px solid #b7cbd4;
    padding-bottom: .5rem;
}

.sticky-button-footer {
    position: sticky;
    bottom: -16px;
    background: #F3F3F3;
    border-top: 1px solid #DEDEDE;
}

.print-block,
.print-flex {
    display: none;
}

@media print {
    html {
        height: auto;
        display: block;
    }

    body {
        height: auto;
        display: block;
        background-color: white;
    }

    #root {
        height: auto;
        display: block;
    }

    #root > div.report-wrapper {
        display: block;
    }

    .report-wrapper .report {
        height: auto;
        display: block;
        width: 100%;
        padding: 0 !important;
        /* padding-top: 3rem !important; */
    }

    .report-wrapper .report .report-page {
        box-shadow: none;
        width: 100%;
        padding: 0 !important;
        margin-top: 0rem !important;
    }

    .report-wrapper .report .report-page .report-page-content {
        padding: 0;
    }

    .report #reportHeader {
        position: fixed;
        top: 0;
        width:100%;
        margin-bottom: 3rem !important;
    }

    .report .reportHeader h1,
    .report .reportHeader h2,
    .report .reportHeader h3 {
        margin-bottom: 0 !important;
    }

    @page {
        @top-center {
            content: element(reportHeader);
        }

        margin: 5mm;
    }

    #reportHeader {
        position: running(reportHeader);
    }

    .report-page h1,
    .report-page h2,
    .report-page h3,
    .report-page h4,
    .report-page h5,
    .report-page h6 {
        margin-top: 0;
    }

    .no-print,
    .flex.no-print,
    .block.no-print {
        display: none !important;
    }

    .print-block {
        display: block;
    }

    .print-flex {
        display: flex;
    }

    .print-zoom-10 {
        zoom: .1;
    }
    .print-zoom-20 {
        zoom: .2;
    }
    .print-zoom-30 {
        zoom: .3;
    }
    .print-zoom-40 {
        zoom: .4;
    }
    .print-zoom-50 {
        zoom: .5;
    }
    .print-zoom-60 {
        zoom: .6;
    }
    .print-zoom-70 {
        zoom: .7;
    }
    .print-zoom-75 {
        zoom: .75;
    }
    .print-zoom-80 {
        zoom: .8;
    }
    .print-zoom-85 {
        zoom: .85;
    }
    .print-zoom-90 {
        zoom: .9;
    }
    .print-zoom-95 {
        zoom: .95;
    }
    .print-zoom-100 {
        zoom: 1;
    }
}

@media (min-width: 1600px) {

    .report .report-page {
        box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    }

    .event-overview .header .date > div:first-of-type {
        font-size: 3.5rem;
    }

    .event-overview .header .date > div:last-of-type {
        font-size: 2rem;
    }

    .event-overview .header .name div:first-of-type {
        font-size: 3rem;
    }

    .event-overview .header .name div:last-of-type {
        font-size: 2rem;
    }

    .event-overview .pane {
        font-size: .8rem;
    }

    .event-overview .pane > .flex-col-2 {
        width: 50%;
    }

    .event-overview .pane > .flex > .flex-col-3,
    .event-overview .pane.flex > .sub-1 {
        width: 32%;
    }

    .page-wrapper main {
        padding: 1.5rem;
        padding-left: 17.75rem;
    }

    .view-only-user .page-wrapper main {
        padding-left: 1rem;
    }
}

p {
    margin-top: .5rem;
    margin-bottom: .5rem;
}

.page-wrapper main h1 {
    margin-top: 0;
}

h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
    font-family: "Muli", Georgia, "Times New Roman", Times, serif;
    line-height: 1.2;
    font-weight: 500;
    letter-spacing: 1px;
    margin-top: 0;
}

h1, .h1 {
    font-size: 2rem;
}

h2, .h2 {
    font-size: 1.74rem;
}

h3, .h3 {
    font-size: 1.51rem;
}

h4, .h4 {
    letter-spacing: 0.05rem;
    font-size: 1.12rem;
}

h5, .h5 {
    font-size: 1.14rem;
}

h6, .h6 {
    font-size: 1rem;
}

/* Display */

.d-none {
    display: none !important;
}

.d-inline {
    display: inline !important;
}

.d-inline-block {
    display: inline-block !important;
}

.d-block {
    display: block !important;
}

.d-table {
    display: table !important;
}

.d-table-row {
    display: table-row !important;
}

.d-table-cell {
    display: table-cell !important;
}

.d-flex {
    display: -ms-flexbox !important;
    display: flex !important;
}

.d-inline-flex {
    display: -ms-inline-flexbox !important;
    display: inline-flex !important;
}


.grid-container:before, .grid-container:after {
    display: table;
    content: " ";
}

.grid-container {
    margin: 0 -1rem;
}

.grid-container:after {
    clear: both;
}

.grid-container .labeled-divider {
    margin-left: 1rem;
    margin-right: 1rem;
}

.grid-container > [class^="xs-"], .grid-container > [class*=" xs-"],
.grid-container > [class^="sm-"], .grid-container > [class*=" sm-"],
.grid-container > [class^="md-"], .grid-container > [class*=" md-"],
.grid-container > [class^="lg-"], .grid-container > [class*=" lg-"],
.grid-container > [class^="xl-"], .grid-container > [class*=" xl-"] {
    padding: 0 1rem;
    float: left;
    width: 100%;
}

.xs-1 {
    width: 8.33333333% !important;
}

.xs-1p5 {
    width: 12.5% !important;
}

.xs-2 {
    width: 16.66666667% !important;
}

.xs-2p5 {
    width: 20.833333333% !important;
}

.xs-3 {
    width: 25% !important;
}

.xs-3p5 {
    width: 29.1666666666% !important;
}

.xs-4 {
    width: 33.33333333% !important;
}

.xs-5 {
    width: 41.66666667% !important;
}

.xs-6 {
    width: 50% !important;
}

.xs-7 {
    width: 58.33333333% !important;
}

.xs-8 {
    width: 66.66666667% !important;
}

.xs-9 {
    width: 75% !important;
}

.xs-10 {
    width: 83.33333333% !important;
}

.xs-10p5 {
    width: 87.5% !important;
}

.xs-11 {
    width: 91.66666667% !important;
}

.xs-12 {
    width: 100% !important;
}


@media (min-width: 576px) {
    html {
        font-size: 16px;
    }

    .d-sm-none {
        display: none !important;
    }
    .d-sm-inline {
        display: inline !important;
    }
    .d-sm-inline-block {
        display: inline-block !important;
    }
    .d-sm-block {
        display: block !important;
    }
    .d-sm-table {
        display: table !important;
    }
    .d-sm-table-row {
        display: table-row !important;
    }
    .d-sm-table-cell {
        display: table-cell !important;
    }
    .d-sm-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
    .d-sm-inline-flex {
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }

    .sm-1 {
        width: 8.33333333% !important;
    }

    .sm-2 {
        width: 16.66666667% !important;
    }

    .sm-3 {
        width: 25% !important;
    }

    .sm-4 {
        width: 33.33333333% !important;
    }

    .sm-5 {
        width: 41.66666667% !important;
    }

    .sm-6 {
        width: 50% !important;
    }

    .sm-7 {
        width: 58.33333333% !important;
    }

    .sm-8 {
        width: 66.66666667% !important;
    }

    .sm-9 {
        width: 75% !important;
    }

    .sm-10 {
        width: 83.33333333% !important;
    }

    .sm-11 {
        width: 91.66666667% !important;
    }

    .sm-12 {
        width: 100% !important;
    }
}

@media (min-width: 768px) {
    .d-md-none {
        display: none !important;
    }
    .d-md-inline {
        display: inline !important;
    }
    .d-md-inline-block {
        display: inline-block !important;
    }
    .d-md-block {
        display: block !important;
    }
    .d-md-table {
        display: table !important;
    }
    .d-md-table-row {
        display: table-row !important;
    }
    .d-md-table-cell {
        display: table-cell !important;
    }
    .d-md-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
    .d-md-inline-flex {
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }
    .d-md-table-header-group {
        display: table-header-group !important;
    }

    .md-1 {
        width: 8.33333333%  !important;
    }

    .md-1p5 {
        width: 12.5% !important;
    }

    .md-2 {
        width: 16.66666667% !important;
    }

    .md-2p5 {
        width: 20.833333333% !important;
    }

    .md-3 {
        width: 25%  !important;
    }

    .md-3p5 {
        width: 29.1666666666% !important;
    }

    .md-4 {
        width: 33.33333333%  !important;
    }

    .md-5 {
        width: 41.66666667%  !important;
    }

    .md-6 {
        width: 50%  !important;
    }

    .md-7 {
        width: 58.33333333%  !important;
    }

    .md-8 {
        width: 66.66666667%  !important;
    }

    .md-9 {
        width: 75%  !important;
    }

    .md-10 {
        width: 83.33333333%  !important;
    }

    .md-11 {
        width: 91.66666667%  !important;
    }

    .md-12 {
        width: 100%  !important;
    }
}

@media (min-width: 992px) {
    .d-lg-none {
        display: none !important;
    }
    .d-lg-inline {
        display: inline !important;
    }
    .d-lg-inline-block {
        display: inline-block !important;
    }
    .d-lg-block {
        display: block !important;
    }
    .d-lg-table {
        display: table !important;
    }
    .d-lg-table-row {
        display: table-row !important;
    }
    .d-lg-table-cell {
        display: table-cell !important;
    }
    .d-lg-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
    .d-lg-inline-flex {
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }

    .lg-1 {
        width: 8.33333333%  !important;
    }

    .lg-2 {
        width: 16.66666667%  !important;
    }

    .lg-3 {
        width: 25%  !important;
    }

    .lg-4 {
        width: 33.33333333%  !important;
    }

    .lg-5 {
        width: 41.66666667%  !important;
    }

    .lg-6 {
        width: 50%  !important;
    }

    .lg-7 {
        width: 58.33333333%  !important;
    }

    .lg-8 {
        width: 66.66666667%  !important;
    }

    .lg-9 {
        width: 75%  !important;
    }

    .lg-10 {
        width: 83.33333333%  !important;
    }

    .lg-11 {
        width: 91.66666667%  !important;
    }

    .lg-12 {
        width: 100%  !important;
    }
}

@media (min-width: 1200px) {
    .d-xl-none {
        display: none !important;
    }
    .d-xl-inline {
        display: inline !important;
    }
    .d-xl-inline-block {
        display: inline-block !important;
    }
    .d-xl-block {
        display: block !important;
    }
    .d-xl-table {
        display: table !important;
    }
    .d-xl-table-row {
        display: table-row !important;
    }
    .d-xl-table-cell {
        display: table-cell !important;
    }
    .d-xl-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
    .d-xl-inline-flex {
        display: -ms-inline-flexbox !important;
        display: inline-flex !important;
    }

    .xl-1 {
        width: 8.33333333%  !important;
    }

    .xl-2 {
        width: 16.66666667%  !important;
    }

    .xl-3 {
        width: 25%  !important;
    }

    .xl-4 {
        width: 33.33333333%  !important;
    }

    .xl-5 {
        width: 41.66666667%  !important;
    }

    .xl-6 {
        width: 50%  !important;
    }

    .xl-7 {
        width: 58.33333333%  !important;
    }

    .xl-8 {
        width: 66.66666667%  !important;
    }

    .xl-9 {
        width: 75%  !important;
    }

    .xl-10 {
        width: 83.33333333%  !important;
    }

    .xl-11 {
        width: 91.66666667%  !important;
    }

    .xl-12 {
        width: 100%  !important;
    }
}


/* Font Sizing */
.xl {
    font-size: 1.5rem;
}

.lg {
    font-size: 1.25rem;
}

.sm {
    font-size: .75rem;
}

.xs {
    font-size: .5rem;
}

.d-hidden {
    display: none !important;
}

.z-1000 { z-index: 1000; }
.z-2000 { z-index: 2000; }
.z-3000 { z-index: 3000; }
.z-4000 { z-index: 4000; }
.z-5000 { z-index: 5000; }


.hotel-report-item {
    padding: .5rem;
}

.hotel-report-item .report-item-header {
    padding: .25rem;
    border: 1px solid #ccc;
}

.hotel-report-item-sub-section {
    padding: .25rem;
    border: 1px solid #ccc;
    border-top: none;
}

fieldset {
    border-color: #DDD;
    border-style: solid;
    border-width: 2px;
}

fieldset legend {
    padding-right: 10px;
    padding-left: 10px;
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,oHAAoH;IACpH,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;AACV;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;;IAEI,WAAW;IACX,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,uBAAuB;IAC3B;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,WAAW;QACX,qBAAqB;QACrB,kCAAkC;IACtC;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,qBAAqB;QACrB,2BAA2B;IAC/B;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,MAAM;QACN,UAAU;QACV,8BAA8B;IAClC;;IAEA;;;QAGI,2BAA2B;IAC/B;;IAEA;QACI;YACI,8BAA8B;QAClC;;QAEA,WAAW;IACf;;IAEA;QACI,+BAA+B;IACnC;;IAEA;;;;;;QAMI,aAAa;IACjB;;IAEA;;;QAGI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,QAAQ;IACZ;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;IACZ;IACA;QACI,SAAS;IACb;IACA;QACI,QAAQ;IACZ;IACA;QACI,SAAS;IACb;IACA;QACI,OAAO;IACX;AACJ;;AAEA;;IAEI;QACI,uEAAuE;IAC3E;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;;QAEI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6DAA6D;IAC7D,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA,YAAY;;AAEZ;IACI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,sCAAsC;IACtC,+BAA+B;AACnC;;;AAGA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;;IAKI,eAAe;IACf,WAAW;IACX,WAAW;AACf;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,sCAAsC;QACtC,+BAA+B;IACnC;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,sCAAsC;QACtC,+BAA+B;IACnC;IACA;QACI,sCAAsC;IAC1C;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,sCAAsC;QACtC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,gCAAgC;IACpC;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,6BAA6B;IACjC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,+BAA+B;QAC/B,wBAAwB;IAC5B;IACA;QACI,sCAAsC;QACtC,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;;AAGA,gBAAgB;AAChB;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,UAAU,aAAa,EAAE;AACzB,UAAU,aAAa,EAAE;AACzB,UAAU,aAAa,EAAE;AACzB,UAAU,aAAa,EAAE;AACzB,UAAU,aAAa,EAAE;;;AAGzB;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":["html {\r\n    height: 100%;\r\n    font-size: 14px;\r\n    line-height: 1.15;\r\n}\r\n\r\nbody {\r\n    margin: 0;\r\n    padding: 0;\r\n    height: 100%;\r\n    font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\r\n    font-size: 1rem;\r\n    font-weight: 400;\r\n    line-height: 1.45;\r\n    background-color: #f3f3f3;\r\n    text-align: left;\r\n    /*color: #55595c;*/\r\n    color: #000;\r\n    overflow-x: hidden;\r\n}\r\n\r\nbody * {\r\n    box-sizing: border-box;\r\n}\r\n\r\n.overflow-x-auto {\r\n    overflow-x: auto;\r\n}\r\n\r\n#root {\r\n    height: 100%;\r\n    display: flex;\r\n}\r\n\r\n#root > div {\r\n    flex: 1;\r\n    display:flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.flex-box {\r\n    display: flex;\r\n}\r\n\r\n.top-of-content-marker {\r\n    position: absolute;\r\n    top: 0;\r\n}\r\n\r\n.bg-white {\r\n    background-color: white !important;\r\n}\r\n\r\n.bg-gray {\r\n    background-color: #fefefe;\r\n}\r\n\r\n.bg-dark-gray {\r\n    background-color: #ccc;\r\n}\r\n\r\n.bg-cyan {\r\n    background-color: #BA324F;\r\n}\r\n.bg-yellow:not(.no-style) {\r\n    background-color: #fff9ae;\r\n}\r\n.bg-baby-blue:not(.no-style) {\r\n    background-color: #b9e4f6;\r\n}\r\n.text-vertical {\r\n    writing-mode: vertical-rl;\r\n}\r\n\r\n.hover-bg-white:hover {\r\n    background-color: white !important;\r\n}\r\n\r\n.hover-bg-gray:hover {\r\n    background-color: #fefefe;\r\n}\r\n\r\n.hover-bg-dark-gray:hover {\r\n    background-color: #ccc;\r\n}\r\n\r\n.hover-bg-cyan:hover {\r\n    background-color: #BA324F;\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer !important;\r\n}\r\n\r\n.no-wrap {\r\n    white-space: nowrap;\r\n}\r\n\r\n.cursor-default {\r\n    cursor: default !important;\r\n}\r\n\r\n.page-wrapper {\r\n    display: flex;\r\n    flex: 1;\r\n    overflow-y: auto;\r\n}\r\n\r\n.page-wrapper main {\r\n    flex: 1;\r\n    min-width: 0;\r\n    padding: 1rem;\r\n    overflow: hidden auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.page-wrapper main > div {\r\n    flex: 1;\r\n    min-width: 0;\r\n}\r\n\r\n.page-wrapper > main > footer {\r\n    font-size: .75rem;\r\n    text-align: center;\r\n    padding-top: 1rem;\r\n}\r\n\r\n.copy-right-container {\r\n    display: flex;\r\n}\r\n\r\n.copy-right-container img {\r\n    margin: auto 0 auto auto;\r\n    height: .75rem;\r\n}\r\n\r\n.copy-right-container span {\r\n    margin: auto auto auto .5rem;\r\n}\r\n\r\n.page-wrapper > main > footer span.loading-placeholder {\r\n    width: 20rem;\r\n}\r\n\r\n.report-wrapper {\r\n    overflow-x: auto;\r\n}\r\n\r\n.report {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    padding: 1rem;\r\n    max-width: 77rem;\r\n    color:black;\r\n}\r\n\r\n.report.allow-overflow {\r\n    max-width: unset;\r\n}\r\n\r\n.report-page table .bg-gray {\r\n    background-color: #EEE;\r\n}\r\n\r\n.report-page table .bg-black {\r\n    background-color: #55595C;\r\n    color: #FFF;\r\n}\r\n\r\n.report-page .user-profile-image {\r\n    width: 5rem;\r\n    height: 5rem;\r\n}\r\n\r\n.report-page .ti-user-alt {\r\n    font-size: 5rem !important;\r\n    color: #efefef;\r\n}\r\n\r\n.report-page table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.report-page td:not(.no-style) {\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.report-page th:not(.no-style) {\r\n    border-bottom: 2px solid #55595c;\r\n}\r\n\r\n.report-page td:not(.no-style), .report-page th:not(.no-style) {\r\n    padding: .5rem;\r\n}\r\n\r\n.report .report-page {\r\n    background: #ffffff;\r\n    padding: 1rem;\r\n}\r\n\r\n.report .report-page + .report-page {\r\n    margin-top: 4rem;\r\n    page-break-before: always;\r\n}\r\n\r\n.event-overview .header {\r\n    display: flex;\r\n}\r\n\r\n.event-overview .header .date {\r\n    background-color: #005377;\r\n    color: white;\r\n    padding: 1rem;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.event-overview .header .date > div:first-of-type {\r\n    font-size: 1.75rem;\r\n}\r\n\r\n.event-overview .header .date > div:last-of-type {\r\n    font-size: 1rem;\r\n}\r\n\r\n.event-overview .header .name {\r\n    border: 1px solid #ccc;\r\n    flex: 1;\r\n    padding: 1rem;\r\n}\r\n\r\n.event-overview .header .name div:first-of-type {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.event-overview .header .name div:last-of-type {\r\n    font-size: .85rem;\r\n}\r\n\r\n.event-overview .pane {\r\n    border: 1px solid #ccc;\r\n    background-color: #f3f3f3;\r\n    font-size: .8rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.event-overview .pane .flex,\r\n.event-overview .pane.flex {\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.event-overview .pane > .flex-col-2 {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    padding: 1rem;\r\n}\r\n\r\n.event-overview .pane > .flex > .flex-col-3,\r\n.event-overview .pane.flex > .sub-1 {\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    padding: 1rem;\r\n}\r\n\r\n.configuration-page .tool-accordion-header {\r\n    border-bottom: 2px solid #b7cbd4;\r\n    padding-bottom: .5rem;\r\n}\r\n\r\n.sticky-button-footer {\r\n    position: sticky;\r\n    bottom: -16px;\r\n    background: #F3F3F3;\r\n    border-top: 1px solid #DEDEDE;\r\n}\r\n\r\n.print-block,\r\n.print-flex {\r\n    display: none;\r\n}\r\n\r\n@media print {\r\n    html {\r\n        height: auto;\r\n        display: block;\r\n    }\r\n\r\n    body {\r\n        height: auto;\r\n        display: block;\r\n        background-color: white;\r\n    }\r\n\r\n    #root {\r\n        height: auto;\r\n        display: block;\r\n    }\r\n\r\n    #root > div.report-wrapper {\r\n        display: block;\r\n    }\r\n\r\n    .report-wrapper .report {\r\n        height: auto;\r\n        display: block;\r\n        width: 100%;\r\n        padding: 0 !important;\r\n        /* padding-top: 3rem !important; */\r\n    }\r\n\r\n    .report-wrapper .report .report-page {\r\n        box-shadow: none;\r\n        width: 100%;\r\n        padding: 0 !important;\r\n        margin-top: 0rem !important;\r\n    }\r\n\r\n    .report-wrapper .report .report-page .report-page-content {\r\n        padding: 0;\r\n    }\r\n\r\n    .report #reportHeader {\r\n        position: fixed;\r\n        top: 0;\r\n        width:100%;\r\n        margin-bottom: 3rem !important;\r\n    }\r\n\r\n    .report .reportHeader h1,\r\n    .report .reportHeader h2,\r\n    .report .reportHeader h3 {\r\n        margin-bottom: 0 !important;\r\n    }\r\n\r\n    @page {\r\n        @top-center {\r\n            content: element(reportHeader);\r\n        }\r\n\r\n        margin: 5mm;\r\n    }\r\n\r\n    #reportHeader {\r\n        position: running(reportHeader);\r\n    }\r\n\r\n    .report-page h1,\r\n    .report-page h2,\r\n    .report-page h3,\r\n    .report-page h4,\r\n    .report-page h5,\r\n    .report-page h6 {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .no-print,\r\n    .flex.no-print,\r\n    .block.no-print {\r\n        display: none !important;\r\n    }\r\n\r\n    .print-block {\r\n        display: block;\r\n    }\r\n\r\n    .print-flex {\r\n        display: flex;\r\n    }\r\n\r\n    .print-zoom-10 {\r\n        zoom: .1;\r\n    }\r\n    .print-zoom-20 {\r\n        zoom: .2;\r\n    }\r\n    .print-zoom-30 {\r\n        zoom: .3;\r\n    }\r\n    .print-zoom-40 {\r\n        zoom: .4;\r\n    }\r\n    .print-zoom-50 {\r\n        zoom: .5;\r\n    }\r\n    .print-zoom-60 {\r\n        zoom: .6;\r\n    }\r\n    .print-zoom-70 {\r\n        zoom: .7;\r\n    }\r\n    .print-zoom-75 {\r\n        zoom: .75;\r\n    }\r\n    .print-zoom-80 {\r\n        zoom: .8;\r\n    }\r\n    .print-zoom-85 {\r\n        zoom: .85;\r\n    }\r\n    .print-zoom-90 {\r\n        zoom: .9;\r\n    }\r\n    .print-zoom-95 {\r\n        zoom: .95;\r\n    }\r\n    .print-zoom-100 {\r\n        zoom: 1;\r\n    }\r\n}\r\n\r\n@media (min-width: 1600px) {\r\n\r\n    .report .report-page {\r\n        box-shadow: 0 10px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);\r\n    }\r\n\r\n    .event-overview .header .date > div:first-of-type {\r\n        font-size: 3.5rem;\r\n    }\r\n\r\n    .event-overview .header .date > div:last-of-type {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .event-overview .header .name div:first-of-type {\r\n        font-size: 3rem;\r\n    }\r\n\r\n    .event-overview .header .name div:last-of-type {\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .event-overview .pane {\r\n        font-size: .8rem;\r\n    }\r\n\r\n    .event-overview .pane > .flex-col-2 {\r\n        width: 50%;\r\n    }\r\n\r\n    .event-overview .pane > .flex > .flex-col-3,\r\n    .event-overview .pane.flex > .sub-1 {\r\n        width: 32%;\r\n    }\r\n\r\n    .page-wrapper main {\r\n        padding: 1.5rem;\r\n        padding-left: 17.75rem;\r\n    }\r\n\r\n    .view-only-user .page-wrapper main {\r\n        padding-left: 1rem;\r\n    }\r\n}\r\n\r\np {\r\n    margin-top: .5rem;\r\n    margin-bottom: .5rem;\r\n}\r\n\r\n.page-wrapper main h1 {\r\n    margin-top: 0;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {\r\n    font-family: \"Muli\", Georgia, \"Times New Roman\", Times, serif;\r\n    line-height: 1.2;\r\n    font-weight: 500;\r\n    letter-spacing: 1px;\r\n    margin-top: 0;\r\n}\r\n\r\nh1, .h1 {\r\n    font-size: 2rem;\r\n}\r\n\r\nh2, .h2 {\r\n    font-size: 1.74rem;\r\n}\r\n\r\nh3, .h3 {\r\n    font-size: 1.51rem;\r\n}\r\n\r\nh4, .h4 {\r\n    letter-spacing: 0.05rem;\r\n    font-size: 1.12rem;\r\n}\r\n\r\nh5, .h5 {\r\n    font-size: 1.14rem;\r\n}\r\n\r\nh6, .h6 {\r\n    font-size: 1rem;\r\n}\r\n\r\n/* Display */\r\n\r\n.d-none {\r\n    display: none !important;\r\n}\r\n\r\n.d-inline {\r\n    display: inline !important;\r\n}\r\n\r\n.d-inline-block {\r\n    display: inline-block !important;\r\n}\r\n\r\n.d-block {\r\n    display: block !important;\r\n}\r\n\r\n.d-table {\r\n    display: table !important;\r\n}\r\n\r\n.d-table-row {\r\n    display: table-row !important;\r\n}\r\n\r\n.d-table-cell {\r\n    display: table-cell !important;\r\n}\r\n\r\n.d-flex {\r\n    display: -ms-flexbox !important;\r\n    display: flex !important;\r\n}\r\n\r\n.d-inline-flex {\r\n    display: -ms-inline-flexbox !important;\r\n    display: inline-flex !important;\r\n}\r\n\r\n\r\n.grid-container:before, .grid-container:after {\r\n    display: table;\r\n    content: \" \";\r\n}\r\n\r\n.grid-container {\r\n    margin: 0 -1rem;\r\n}\r\n\r\n.grid-container:after {\r\n    clear: both;\r\n}\r\n\r\n.grid-container .labeled-divider {\r\n    margin-left: 1rem;\r\n    margin-right: 1rem;\r\n}\r\n\r\n.grid-container > [class^=\"xs-\"], .grid-container > [class*=\" xs-\"],\r\n.grid-container > [class^=\"sm-\"], .grid-container > [class*=\" sm-\"],\r\n.grid-container > [class^=\"md-\"], .grid-container > [class*=\" md-\"],\r\n.grid-container > [class^=\"lg-\"], .grid-container > [class*=\" lg-\"],\r\n.grid-container > [class^=\"xl-\"], .grid-container > [class*=\" xl-\"] {\r\n    padding: 0 1rem;\r\n    float: left;\r\n    width: 100%;\r\n}\r\n\r\n.xs-1 {\r\n    width: 8.33333333% !important;\r\n}\r\n\r\n.xs-1p5 {\r\n    width: 12.5% !important;\r\n}\r\n\r\n.xs-2 {\r\n    width: 16.66666667% !important;\r\n}\r\n\r\n.xs-2p5 {\r\n    width: 20.833333333% !important;\r\n}\r\n\r\n.xs-3 {\r\n    width: 25% !important;\r\n}\r\n\r\n.xs-3p5 {\r\n    width: 29.1666666666% !important;\r\n}\r\n\r\n.xs-4 {\r\n    width: 33.33333333% !important;\r\n}\r\n\r\n.xs-5 {\r\n    width: 41.66666667% !important;\r\n}\r\n\r\n.xs-6 {\r\n    width: 50% !important;\r\n}\r\n\r\n.xs-7 {\r\n    width: 58.33333333% !important;\r\n}\r\n\r\n.xs-8 {\r\n    width: 66.66666667% !important;\r\n}\r\n\r\n.xs-9 {\r\n    width: 75% !important;\r\n}\r\n\r\n.xs-10 {\r\n    width: 83.33333333% !important;\r\n}\r\n\r\n.xs-10p5 {\r\n    width: 87.5% !important;\r\n}\r\n\r\n.xs-11 {\r\n    width: 91.66666667% !important;\r\n}\r\n\r\n.xs-12 {\r\n    width: 100% !important;\r\n}\r\n\r\n\r\n@media (min-width: 576px) {\r\n    html {\r\n        font-size: 16px;\r\n    }\r\n\r\n    .d-sm-none {\r\n        display: none !important;\r\n    }\r\n    .d-sm-inline {\r\n        display: inline !important;\r\n    }\r\n    .d-sm-inline-block {\r\n        display: inline-block !important;\r\n    }\r\n    .d-sm-block {\r\n        display: block !important;\r\n    }\r\n    .d-sm-table {\r\n        display: table !important;\r\n    }\r\n    .d-sm-table-row {\r\n        display: table-row !important;\r\n    }\r\n    .d-sm-table-cell {\r\n        display: table-cell !important;\r\n    }\r\n    .d-sm-flex {\r\n        display: -ms-flexbox !important;\r\n        display: flex !important;\r\n    }\r\n    .d-sm-inline-flex {\r\n        display: -ms-inline-flexbox !important;\r\n        display: inline-flex !important;\r\n    }\r\n\r\n    .sm-1 {\r\n        width: 8.33333333% !important;\r\n    }\r\n\r\n    .sm-2 {\r\n        width: 16.66666667% !important;\r\n    }\r\n\r\n    .sm-3 {\r\n        width: 25% !important;\r\n    }\r\n\r\n    .sm-4 {\r\n        width: 33.33333333% !important;\r\n    }\r\n\r\n    .sm-5 {\r\n        width: 41.66666667% !important;\r\n    }\r\n\r\n    .sm-6 {\r\n        width: 50% !important;\r\n    }\r\n\r\n    .sm-7 {\r\n        width: 58.33333333% !important;\r\n    }\r\n\r\n    .sm-8 {\r\n        width: 66.66666667% !important;\r\n    }\r\n\r\n    .sm-9 {\r\n        width: 75% !important;\r\n    }\r\n\r\n    .sm-10 {\r\n        width: 83.33333333% !important;\r\n    }\r\n\r\n    .sm-11 {\r\n        width: 91.66666667% !important;\r\n    }\r\n\r\n    .sm-12 {\r\n        width: 100% !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n    .d-md-none {\r\n        display: none !important;\r\n    }\r\n    .d-md-inline {\r\n        display: inline !important;\r\n    }\r\n    .d-md-inline-block {\r\n        display: inline-block !important;\r\n    }\r\n    .d-md-block {\r\n        display: block !important;\r\n    }\r\n    .d-md-table {\r\n        display: table !important;\r\n    }\r\n    .d-md-table-row {\r\n        display: table-row !important;\r\n    }\r\n    .d-md-table-cell {\r\n        display: table-cell !important;\r\n    }\r\n    .d-md-flex {\r\n        display: -ms-flexbox !important;\r\n        display: flex !important;\r\n    }\r\n    .d-md-inline-flex {\r\n        display: -ms-inline-flexbox !important;\r\n        display: inline-flex !important;\r\n    }\r\n    .d-md-table-header-group {\r\n        display: table-header-group !important;\r\n    }\r\n\r\n    .md-1 {\r\n        width: 8.33333333%  !important;\r\n    }\r\n\r\n    .md-1p5 {\r\n        width: 12.5% !important;\r\n    }\r\n\r\n    .md-2 {\r\n        width: 16.66666667% !important;\r\n    }\r\n\r\n    .md-2p5 {\r\n        width: 20.833333333% !important;\r\n    }\r\n\r\n    .md-3 {\r\n        width: 25%  !important;\r\n    }\r\n\r\n    .md-3p5 {\r\n        width: 29.1666666666% !important;\r\n    }\r\n\r\n    .md-4 {\r\n        width: 33.33333333%  !important;\r\n    }\r\n\r\n    .md-5 {\r\n        width: 41.66666667%  !important;\r\n    }\r\n\r\n    .md-6 {\r\n        width: 50%  !important;\r\n    }\r\n\r\n    .md-7 {\r\n        width: 58.33333333%  !important;\r\n    }\r\n\r\n    .md-8 {\r\n        width: 66.66666667%  !important;\r\n    }\r\n\r\n    .md-9 {\r\n        width: 75%  !important;\r\n    }\r\n\r\n    .md-10 {\r\n        width: 83.33333333%  !important;\r\n    }\r\n\r\n    .md-11 {\r\n        width: 91.66666667%  !important;\r\n    }\r\n\r\n    .md-12 {\r\n        width: 100%  !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n    .d-lg-none {\r\n        display: none !important;\r\n    }\r\n    .d-lg-inline {\r\n        display: inline !important;\r\n    }\r\n    .d-lg-inline-block {\r\n        display: inline-block !important;\r\n    }\r\n    .d-lg-block {\r\n        display: block !important;\r\n    }\r\n    .d-lg-table {\r\n        display: table !important;\r\n    }\r\n    .d-lg-table-row {\r\n        display: table-row !important;\r\n    }\r\n    .d-lg-table-cell {\r\n        display: table-cell !important;\r\n    }\r\n    .d-lg-flex {\r\n        display: -ms-flexbox !important;\r\n        display: flex !important;\r\n    }\r\n    .d-lg-inline-flex {\r\n        display: -ms-inline-flexbox !important;\r\n        display: inline-flex !important;\r\n    }\r\n\r\n    .lg-1 {\r\n        width: 8.33333333%  !important;\r\n    }\r\n\r\n    .lg-2 {\r\n        width: 16.66666667%  !important;\r\n    }\r\n\r\n    .lg-3 {\r\n        width: 25%  !important;\r\n    }\r\n\r\n    .lg-4 {\r\n        width: 33.33333333%  !important;\r\n    }\r\n\r\n    .lg-5 {\r\n        width: 41.66666667%  !important;\r\n    }\r\n\r\n    .lg-6 {\r\n        width: 50%  !important;\r\n    }\r\n\r\n    .lg-7 {\r\n        width: 58.33333333%  !important;\r\n    }\r\n\r\n    .lg-8 {\r\n        width: 66.66666667%  !important;\r\n    }\r\n\r\n    .lg-9 {\r\n        width: 75%  !important;\r\n    }\r\n\r\n    .lg-10 {\r\n        width: 83.33333333%  !important;\r\n    }\r\n\r\n    .lg-11 {\r\n        width: 91.66666667%  !important;\r\n    }\r\n\r\n    .lg-12 {\r\n        width: 100%  !important;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    .d-xl-none {\r\n        display: none !important;\r\n    }\r\n    .d-xl-inline {\r\n        display: inline !important;\r\n    }\r\n    .d-xl-inline-block {\r\n        display: inline-block !important;\r\n    }\r\n    .d-xl-block {\r\n        display: block !important;\r\n    }\r\n    .d-xl-table {\r\n        display: table !important;\r\n    }\r\n    .d-xl-table-row {\r\n        display: table-row !important;\r\n    }\r\n    .d-xl-table-cell {\r\n        display: table-cell !important;\r\n    }\r\n    .d-xl-flex {\r\n        display: -ms-flexbox !important;\r\n        display: flex !important;\r\n    }\r\n    .d-xl-inline-flex {\r\n        display: -ms-inline-flexbox !important;\r\n        display: inline-flex !important;\r\n    }\r\n\r\n    .xl-1 {\r\n        width: 8.33333333%  !important;\r\n    }\r\n\r\n    .xl-2 {\r\n        width: 16.66666667%  !important;\r\n    }\r\n\r\n    .xl-3 {\r\n        width: 25%  !important;\r\n    }\r\n\r\n    .xl-4 {\r\n        width: 33.33333333%  !important;\r\n    }\r\n\r\n    .xl-5 {\r\n        width: 41.66666667%  !important;\r\n    }\r\n\r\n    .xl-6 {\r\n        width: 50%  !important;\r\n    }\r\n\r\n    .xl-7 {\r\n        width: 58.33333333%  !important;\r\n    }\r\n\r\n    .xl-8 {\r\n        width: 66.66666667%  !important;\r\n    }\r\n\r\n    .xl-9 {\r\n        width: 75%  !important;\r\n    }\r\n\r\n    .xl-10 {\r\n        width: 83.33333333%  !important;\r\n    }\r\n\r\n    .xl-11 {\r\n        width: 91.66666667%  !important;\r\n    }\r\n\r\n    .xl-12 {\r\n        width: 100%  !important;\r\n    }\r\n}\r\n\r\n\r\n/* Font Sizing */\r\n.xl {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.lg {\r\n    font-size: 1.25rem;\r\n}\r\n\r\n.sm {\r\n    font-size: .75rem;\r\n}\r\n\r\n.xs {\r\n    font-size: .5rem;\r\n}\r\n\r\n.d-hidden {\r\n    display: none !important;\r\n}\r\n\r\n.z-1000 { z-index: 1000; }\r\n.z-2000 { z-index: 2000; }\r\n.z-3000 { z-index: 3000; }\r\n.z-4000 { z-index: 4000; }\r\n.z-5000 { z-index: 5000; }\r\n\r\n\r\n.hotel-report-item {\r\n    padding: .5rem;\r\n}\r\n\r\n.hotel-report-item .report-item-header {\r\n    padding: .25rem;\r\n    border: 1px solid #ccc;\r\n}\r\n\r\n.hotel-report-item-sub-section {\r\n    padding: .25rem;\r\n    border: 1px solid #ccc;\r\n    border-top: none;\r\n}\r\n\r\nfieldset {\r\n    border-color: #DDD;\r\n    border-style: solid;\r\n    border-width: 2px;\r\n}\r\n\r\nfieldset legend {\r\n    padding-right: 10px;\r\n    padding-left: 10px;\r\n    font-weight: bold;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
